/* eslint-disable */
/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
import Header from './site/header';
import EqualHeights from './site/equalHeights';
import Append from './site/append';
import ProductsRelated from './site/productsRelated';
import Popups from './site/popups';
import CompareBar from './site/compareBar';
import Wishlist from './site/wishlist';
import CompareProducts from './site/comapreProducts';
import RegisterForm from './site/registerForm';
import AddToCart from './site/addToCart';
import CartPage from './site/cartPage';
import Tabs from './site/tabs';
import Shop from './site/shop';
import SingleProduct from './site/singleProduct';
import Filters from './site/filters';
import Loaders from './site/loaders';
import IdbHandler from './idb/idbHandler';
import SearchAjax from './site/search-ajax';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	Header.init();
	EqualHeights.init();
	Append.init();
	ProductsRelated.init();
	Popups.init();
	// CompareBar.init();
	Wishlist.init();
	// CompareProducts.init();
	RegisterForm.init();
	AddToCart.init();
	CartPage.init();
	Tabs.init();
	Shop.init();
	SingleProduct.init();
	Filters.init();
	Loaders.init();
	IdbHandler.init();
	SearchAjax.init();
});
